<template lang="pug">
    article.news-list(@scroll='handleScroll', ref='wrap')
        BlockVisibilityTrigger(:theme='"black"')

        .news-list__wrap
            h1.news-list__title.h1(v-html="news.title")
            .news-list__list(ref='list')
                router-link.news-list__item(
                    v-for='{date, title, lead, photo, id} = item in currentSetNews'
                    :to='"/news/" + id',
                    :key='id',
                    v-observe-visibility='visibilityChanged')
                    .news-list__photo
                        img(:src='require(`@/assets/img/news/${photo}`)', :alt='title')
                        time.news-list__date {{date | formatDate}}
                    .news-list__description
                        .news-list__name(v-html='title')
                        .news-list__text(v-html='lead')

            button.news-list__btn(
                v-if='buttonAddIsActive',
                v-html='news.btn',
                @click='addNews')

        Footer

</template>

<script>
import newsData from '../assets/data/news.json';
import Footer from '../components/Footer.vue';
import BlockVisibilityTrigger from '../components/BlockVisibilityTrigger.vue';

const sortedNews = newsData.list
    .sort((a, b) => {
        const bDate = new Date(b.date).getTime();
        const aDate = new Date(a.date).getTime();

        return bDate === aDate ? b.id - a.id : bDate - aDate;
    })
    .filter(news => !news.hidden);

export default {
    name: 'NewsList',

    components: {
        Footer,
        BlockVisibilityTrigger
    },

    data() {
        return {
            news: sortedNews,
            setSize: 6,
            countItemsInSet: 6,
            buttonAddIsActive: true,
            loading: false
        };
    },

    computed: {
        currentSetNews() {
            return this.news.slice(0, this.countItemsInSet);
        }
    },

    beforeMount() {
        // this.news.list.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
    },

    mounted() {},

    watch: {
        countItemsInSet(to) {
            if (this.news.length - to <= this.setSize && this.news.length - to > 0) {
                this.setSize = this.news.list.length - to;
            } else if (this.news.length - to <= 0) {
                this.buttonAddIsActive = false;
            }
        }
    },

    filters: {
        formatDate(value) {
            const date = new Date(value);
            return `${`${date.getDate()}`.padStart(2, 0)}.${`${date.getMonth() + 1}`.padStart(2, 0)}.${date.getFullYear()}`;
        }
    },

    methods: {
        loadNews() {
            // fetch();
        },
        addNews() {
            this.loading = true;
            // this.loadNews()
            // .then(res => {
            // this.news = res;
            this.countItemsInSet += this.setSize;
            this.loading = false;
            // })
        },
        handleScroll() {
            const height = this.$refs.wrap.offsetHeight;
            const bottom = this.$refs.list.getBoundingClientRect().bottom;
            // console.log({doc: height, bottom});
            // console.log(height >= bottom);
            if (height >= bottom && !this.loading) {
                this.addNews();
            }
        },
        visibilityChanged(e, el) {
            if (e) {
                el.target.classList.add('show');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';
@import '../assets/css/base.scss';

:root {
    --vh: 5.68px;
}

.news-list {
    padding-top: 8em;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    @supports (--css: variables) {
        height: calc(var(--vh) * 100);
    }

    @media (--viewport-tablet) {
        padding-top: 5em;
    }

    &__wrap {
        width: calc(var(--layout-column-width) * 8 + var(--layout-gutter-width) * 7);
        margin: 0 auto;
        padding-bottom: 6.6em;

        @media (--viewport-tablet) {
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
            padding-bottom: 6em;
        }
    }

    &__title {
        text-align: center;
        margin-bottom: 2em;

        @media (--viewport-tablet) {
            margin-bottom: 1.5em;
        }
    }

    &__list {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 1em;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-column-gap: var(--layout-gutter-width);

        @media (--viewport-tablet) {
            margin-bottom: 0.7em;
            display: flex;
            flex-wrap: wrap;
        }
    }

    &__item {
        display: flex;
        flex-direction: column;
        width: calc(var(--layout-column-width) * 2 + var(--layout-gutter-width) * 1);
        text-decoration: none;
        color: currentColor;
        margin-bottom: 3.6em;
        margin-right: var(--layout-gutter-width);
        opacity: 0;
        transform: translateY(50px);

        @supports (display: grid) {
            width: 100%;
        }

        &.show {
            opacity: 1;
            transform: translateY(0px);
            transition: opacity 1s ease 0.2s, transform 1s cubic-bezier(0.39, 0.575, 0.565, 1) 0.2s;
        }

        &:nth-child(4n) {
            margin-right: 0;
        }

        @media (--viewport-tablet) {
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
            margin-right: 0;
            margin-bottom: 2.7em;
        }
    }

    &__photo {
        position: relative;

        img {
            width: 100%;
        }
    }

    &__date {
        display: inline-block;
        position: absolute;
        bottom: 0;
        left: 0;
        font-size: 0.6em;
        font-weight: 350;
        padding: 0.8em 1.5em;
        background-color: var(--color-main-bg);

        @media (--viewport-tablet) {
            font-size: 1em;
            padding: 0.4em 1.5em;
        }
    }

    &__description {
        background-color: var(--color-main-bg);
        font-size: 0.6em;
        padding: 1.5em 1.5em 2.8em;
        flex-grow: 1;

        @media (--viewport-tablet) {
            font-size: 1em;
            padding-bottom: 2em;
        }
    }

    &__name {
        font-family: var(--font-accent);
        text-transform: uppercase;
        margin-bottom: 1.5em;

        @media (--viewport-tablet) {
            font-size: 1em;
        }
    }

    &__text {
        font-size: 1.33em;

        @media (--viewport-tablet) {
            font-size: 1em;
        }
    }

    &__btn {
        margin: 0 auto;
        display: block;
        color: var(--color-accent-text);
        font-family: var(--font-accent);
        text-transform: uppercase;
        padding: 0.5em 0.5em 0.3em;
        border: 4px solid var(--color-main-bg);

        &:hover,
        &:focus {
            color: var(--color-main-text);
            background-color: var(--color-main-bg);
            border: 4px solid transparent;
        }
    }
}
</style>
